export function StatusPill({ status }: { status: string }) {
  const styles: Record<string, string> = {
    'Em análise': 'bg-amber-100 text-amber-900 border-amber-200',
    Mitigada: 'bg-emerald-100 text-emerald-900 border-emerald-200',
    Encerrada: 'bg-secondary text-muted-foreground border-border',
    Nova: 'bg-primary/10 text-primary border-primary/20',
  }
  return (
    <span
      className={`hidden rounded-full border px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-wider md:inline-block ${styles[status] ?? ''}`}
    >
      {status}
    </span>
  )
}

export function SeverityPill({ severity }: { severity: string }) {
  const styles: Record<string, string> = {
    Crítica: 'bg-red-100 text-red-900',
    Alta: 'bg-orange-100 text-orange-900',
    Média: 'bg-amber-100 text-amber-900',
    Baixa: 'bg-secondary text-muted-foreground',
  }
  return (
    <span
      className={`hidden rounded px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider sm:inline-block ${styles[severity] ?? ''}`}
    >
      {severity}
    </span>
  )
}
